<template>
  <div class="index">
    <div class="flex-box index-hd border-bottom-line">
      <div class="flex-box-hd">
        <a @click="handleLinkTo">
          <img class="logo" :src="logo" />
        </a>
      </div>
      <!-- <div class="org-name mg-right20">{{loadData.org_cname}}</div> -->
      <!--            <div class="mg-right15" v-if="loadData.org_level != '0'">-->
      <!--                <Dropdown trigger="click" class="back-dropdown" @on-click="cloudBoxClick">-->
      <!--                    <a class="f13 f-white" href="javascript:void(0)">-->
      <!--                        {{$t('cloud_service')}}-->
      <!--                        <Icon type="ios-arrow-down"></Icon>-->
      <!--                    </a>-->
      <!--                    <DropdownMenu slot="list">-->
      <!--                        <DropdownItem name="link_yfee" class="f14"><Icon type="logo-yen" /> {{ $t("link_yfee")}}</DropdownItem>-->
      <!--                        <DropdownItem name="link_exwrap">{{ $t("link_exwrap") }}</DropdownItem>-->
      <!--                        <DropdownItem name="link_msg">{{ $t("link_msg") }}</DropdownItem>-->
      <!--                    </DropdownMenu>-->
      <!--                </Dropdown>-->
      <!--            </div>-->
      <!--            <div class="mg-right5" v-if="loadData.org_level != '0'">-->
      <!--                <Icon class="f15 f-white" type="ios-cart" />-->
      <!--            </div>-->
      <!--            <div class="mg-right15" v-if="loadData.org_level != '0'">-->
      <!--                <a class="f13 f-white" @click="$base.linkTo(`/cloud/product?fid=130&fn=${$t('link_wlsc')}`)">{{$t('link_wlsc')}}</a>-->
      <!--            </div>-->
      <!--            <div class="mg-right15" v-if="loadData.org_level != '0'">-->
      <!--                <a class="f13 f-white" @click="$base.linkTo(`/cloud/recharges123?fid=86&fn=${$t('online_recharge')}`)">{{$t('recharge')}}</a>-->
      <!--            </div>-->
      <!-- <Poptip :transfer="true" placement="bottom">
                <div class="flex-box nopadding">
                    <Icon class="f15 f-white mg-right5" type="ios-cube-outline" />
                    <a class="f13 f-white un-select mg-right10">{{$t('coll_dir')}}</a>
                </div>
                <div slot="title">
                    <div class="tcenter"><Button type="primary" icon="md-add" @click="collFunc">{{$t('coll_add')}}</Button></div>
                </div>
                <div slot="content">
                    <div v-if="loadData.coll_menu_list.length == 0">{{$t('coll_un')}}</div>
                    <div v-else class="col-box col2" style="width: 300px;max-height: 80vh;overflow: auto">
                        <div class="col-box-item mg-bottom3 bg-f8 pd-3 round-2" v-for="(item, index) in loadData.coll_menu_list" :key="index">
                            <div class="flex-box nopadding">
                                <div class="mg-left3 mg-right3 hand del" @click="highColl(index, item.coll_id, item.high_flag)" :class="item.high_flag == '1'?'f-red':'f-gray'"><Icon class="f14" type="md-flag" /></div>
                                <div class="mg-right3 f-gray hand del" @click="deleteColl(index, item.coll_id)" v-if="item.high_flag == '0'"><Icon class="f14" type="md-trash" /></div>
                                <div class="flex-box-bd tleft"><a class="f13 un-select" :class="item.high_flag == '1'?'f-red':'f-black'" @click="collFuncClick(item)">{{item.func_cname}}</a></div>
                            </div>
                        </div>
                    </div>
                </div>
      </Poptip>-->
      <div class="flex-box-bd"></div>
      <div class="tright">
        <div class="flex-box mline bk right-box">
          <div class="mg-right10">
            <div class="user-box">
              <img src="../assets/img/df_userimg.png" />
            </div>
          </div>
          <div class="mg-right10">
            <Dropdown trigger="click" @on-click="userBoxClick">
              <a class="f13 f-green" href="javascript:void(0)">
                {{loadData.user_code}}
                <Icon type="ios-arrow-down"></Icon>
              </a>
              <DropdownMenu slot="list">
                <DropdownItem name="reset_pwd">{{ $t("reset_pwd")}}</DropdownItem>
                <DropdownItem name="logout">{{ $t("exit") }}</DropdownItem>
              </DropdownMenu>
            </Dropdown>
          </div>
          <div class="mg-right10">
            <a class="f13 f-green" @click="openRole">
              {{loadData.role_cname}}
              <Icon type="ios-arrow-down"></Icon>
            </a>
          </div>
          <!--                    <div class="mg-right10" v-if="loadData.org_level == '1'">-->
          <!--                        <a class="f13 f-yellow" @click="$router.push({path: `/mk/com1sm?fid=1320&fn=${$t('msg_from3')}`})">{{$t('send_msg')}}</a>-->
          <!--                    </div>-->
          <myDropdown
            class="f13 f-green"
            :list="$config.langs"
            v-model="lang"
            key_name="val"
            value_name="key"
            @onChange="langBoxClick"
          ></myDropdown>
        </div>
      </div>
    </div>
    <div class="flex-box index-bd">
      <div class="left-box mini-scrollbar border-r">
        <div class="item1">
          <!-- <div class="img-box">
                        <img :src="`${$config.imgUrl}index_bar.jpg`"/>
          </div>-->
          <Menu
            ref="menu"
            width="auto"
            accordion
            :open-names="menu_open_names"
            :active-name="menu_active_name"
          >
            <Submenu :name="item.web_url" v-for="(item,index) in loadData.menu_list" :key="index">
              <template slot="title">
                <Icon :type="item.icon" :color="item.color" />
                <span style="font-size: 15px">{{item.func_cname}}</span>
              </template>
              <!--replace-->
              <MenuItem
                :name="item2.web_url"
                :to="item2.web_url+'?fid='+item2.func_id+'&fn='+item2.func_cname"
                v-for="(item2,index2) in item.children"
                :key="index2"
              >
                <span style="font-size: 15px">• {{item2.func_cname}}</span>
              </MenuItem>
            </Submenu>
          </Menu>
        </div>
      </div>
      <div class="flex-box-bd right-box">
        <div class="flex-box col fillwh">
          <div style="min-height: 44px" v-show="menu_opens.length > 0">
            <myMenuOpens />
          </div>
          <div class="flex-box-bd" style="position: relative">
            <keep-alive :include="menu_opens_name" :max="$config.cache_page_qty * 2">
              <router-view class="sub-view pd-10"></router-view>
            </keep-alive>
          </div>
        </div>
      </div>
    </div>
    <Modal v-model="show_reset_pwd" width="360" :mask-closable="false">
      <p slot="header" style="color:#f60;text-align:center">
        <Icon class="f16" type="ios-information-circle"></Icon>
        <span class="f16">{{ $t("reset_pwd")}}</span>
      </p>
      <div class="f14">
        <Row style="margin-bottom: 10px" type="flex" align="middle">
          <Col span="7">{{$t('new_password')}}:</Col>
          <Col span="17">
            <Input
              ref="user_pwd"
              v-model="password.user_pwd"
              type="password"
              size="large"
              @on-enter="resetPwd"
            />
          </Col>
        </Row>
        <Row type="flex" align="middle">
          <Col span="7">{{$t('fix_password')}}:</Col>
          <Col span="17">
            <Input v-model="password.user_pwd2" type="password" size="large" @on-enter="resetPwd" />
          </Col>
        </Row>
      </div>
      <div slot="footer">
        <Button type="error" size="large" long @click="resetPwd">{{ $t("save")}}</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import myDropdown from '../components/myDropdown'
import myMenuOpens from '../components/myMenuOpens'
import { msgErr, setOrgLevel } from "../utils/base";
export default {
  name: "index",
  components: {
    myDropdown,
    myMenuOpens
  },
  data () {
    return {
      logo: require("@/assets/img/logo.png"),
      lang: this.$base.getLang(),
      show_reset_pwd: false,
      loadData: {
        user_code: this.$t("unknown"),
        role_cname: this.$t("unknown"),
        org_cname: this.$t("unknown"),
        org_level: '',
        menu_list: [],
        coll_menu_list: []
      },
      password: {
        user_pwd: '',
        user_pwd2: ''
      },
    }
  },
  computed: {
    base_reload () {
      return this.$store.state.baseData.base_reload;
    },
    menu_open_names () {
      return [this.menu_active_name.split('/')[1]];
    },
    menu_active_name () {
      var ss = this.$store.state.baseData.menu_active_name.split('/');
      return '/' + ss[1] + '/' + ss[2];
    },
    menu_opens_name () {
      return this.$store.state.baseData.menu_opens_name;
    },
    menu_opens () {
      return this.$store.state.baseData.menu_opens;
    }
  },
  mounted () {
    document.title = this.$t('sys_name');
    this.load();
  },
  methods: {
    load () {
      this.$store.dispatch("setBaseData_baseReload", false);
      this.$base.showLoading();
      this.$request.sendPost("user/base", {}, (success, data, error) => {
        this.$base.hideLoading();
        if (success) {
          this.$base.setOrgLevel(data.org_level);
          this.loadData.user_code = data.user_code;
          this.loadData.role_cname = data.role_cname;
          this.loadData.org_cname = data.org_cname;
          this.loadData.org_level = data.org_level;
          this.loadData.coll_menu_list = data.coll_menu_list;
          this.loadData.menu_list = data.menu_list;
          this.changeMenu();
        }
        else {
          this.$base.alertErr(error.errmsg);
        }
      });
    },
    deleteColl (index, coll_id) {
      const data = {
        coll_id
      }
      this.$request.sendPost('user/del-coll-func', data, (success, data, error) => {
        this.$base.hideLoading();
        if (success) {
          this.loadData.coll_menu_list.splice(index, 1)
          this.$base.msgSuccess(this.$t('op_ok'));
        }
        else {
          this.$base.alertErr(error.errmsg);
        }
      });
    },
    highColl (index, coll_id, high_flag) {
      const data = {
        coll_id,
        high_flag: high_flag == '1' ? '0' : '1'
      }
      this.$request.sendPost('user/high-coll-func', data, (success, data, error) => {
        this.$base.hideLoading();
        if (success) {
          if (high_flag == '1') {
            this.loadData.coll_menu_list[index].high_flag = '0'
          } else {
            this.loadData.coll_menu_list[index].high_flag = '1'
          }
          this.$base.msgSuccess(this.$t('op_ok'));
        }
        else {
          this.$base.alertErr(error.errmsg);
        }
      });
    },
    userBoxClick (name) {
      if (name == "logout") {
        this.$base.logout();
      }
      else if (name == "reset_pwd") {
        this.show_reset_pwd = true;
      }
    },
    cloudBoxClick (name) {
      if (name == "link_yfee") {
        this.$base.linkTo(`/cloud/yfee?fid=99&fn=${this.$t('link_yfee')}`);
      }
      else if (name == "link_exwrap") {
        this.$base.linkTo(`/cloud/exwrap?fid=119&fn=${this.$t('link_exwrap')}`);
      }
      else if (name == "link_msg") {
        this.$base.linkTo(`/cloud/msg?fid=109&fn=${this.$t('link_msg')}`);
      }
    },
    langBoxClick: function (data) {
      this.$base.setLangCookie(this, data.key);
      //   this.$base.replaceTo('/');
      //   this.load();
      location.reload()
    },
    changeMenu: function () {
      this.$nextTick(() => {
        this.$refs.menu.updateOpened();//手动更新展开的子目录，注意要在 $nextTick 里调用
        this.$refs.menu.updateActiveName();//	手动更新当前选择项，注意要在 $nextTick 里调用
      });
    },
    openRole: function () {
      this.$base.openRole();
    },
    resetPwd: function () {
      var user_pwd = this.password.user_pwd;
      if (user_pwd == "") {
        this.$base.alertErr(this.$t('pwd_err'));
        return;
      }
      if (user_pwd != this.password.user_pwd2) {
        this.$base.alertErr(this.$t('pwd_err'));
        return;
      }
      var data = {
        user_pwd: this.$base.toMD5(user_pwd)
      };
      this.$base.showLoading();
      this.$request.sendPost('user/set-pwd-by-self', data, (success, data, error) => {
        this.$base.hideLoading();
        if (success) {
          this.show_reset_pwd = false;
          this.password.user_pwd = '';
          this.password.user_pwd2 = '';
          this.$base.alertSuccess(error.errmsg);
        }
        else {
          this.$base.alertErr(error.errmsg);
        }
      });
    },
    collFunc: function () {
      var func_id = this.$base.getRequest().fid;
      if (!func_id && func_id == "") {
        this.$base.msgErr(this.$t('coll_func_err'));
        return;
      }
      var data = {
        func_id: func_id
      };
      this.$base.showLoading();
      this.$request.sendPost('user/coll-func', data, (success, data, error) => {
        this.$base.hideLoading();
        if (success) {
          this.loadData.coll_menu_list.push(data);
          console.log('this.loadData.coll_menu_list', this.loadData.coll_menu_list)
        }
        else {
          this.$base.msgErr(error.errmsg);
        }
      });
    },
    collFuncClick: function (item) {
      this.$base.linkTo(`${item.web_url}?fid=${item.func_id}&fn=${item.func_cname}`);
      document.body.click();
    },
    handleLinkTo: function () {
      this.$base.linkTo('index/welcome');
    }
  },
  watch: {
    //检测到路径变化时更新菜单
    menu_open_names (newVal, oldVal) {
      this.changeMenu();
    },
    base_reload (newVal, oldVal) {
      if (newVal) {
        this.load();
      }
    }
  }
}
</script>

<style scoped>
.index {
  /*max-width: 1300px;*/
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: 0 auto;
  overflow: hidden;
}
.index-hd {
  height: 60px;
  background-color: #fff;
  padding: 0;
  font-size: 0;
}
.index-hd .flex-box-hd {
  width: 250px;
  display: flex;
  justify-content: center;
}
.index-hd .flex-box-hd .logo {
  width: 100%;
  height: 45px;
}
.index-hd .flex-box-bd {
}
.index-hd .org-name {
  font-size: 14px;
  font-weight: bold;
  color: #fbab18;
}
.index-hd .logo-text {
  font-size: 12px;
  color: #d3d3d3;
}
.index-hd .right-box {
  font-size: 12px;
  color: #fbab18;
}
.index-hd .right-box .user-box {
  width: 28px;
  height: 28px;
}
.index-hd .right-box .user-box img {
  width: 100%;
  height: 100%;
}

.index-bd {
  position: absolute;
  top: 60px;
  left: -1px;
  right: 0;
  bottom: 0;
  background-color: #f0f0f0;
  padding: 0;
  text-align: unset;
}
.index-bd .left-box {
  width: 250px;
  height: 100%;
  overflow-y: auto;
  background-color: #fff;
  border-left: solid 1px #e5e5e5;
}
.index-bd .left-box .item1 .img-box {
  padding: 5px 5px 0 4px;
}
.index-bd .left-box .item1 .img-box img {
  width: 100%;
  height: 72px;
}
.index-bd .left-box .ivu-menu {
  font-weight: bold;
  font-size: 14px;
}
.index-bd .left-box .ivu-menu .ivu-icon {
  font-size: 17px;
}
.index-bd .right-box {
  position: relative;
  width: 100%;
  height: 100%;
}
.index-bd .right-box .sub-view {
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  overflow: auto;
}
.border-r {
  border-right: 1px solid #e5e5e5;
}
.ivu-menu-light {
  background-color: #fff;
  color: var(--green_two);
}
.ivu-menu-vertical .ivu-menu-submenu .ivu-menu-item {
  background-color: #fff;
  color: var(--green_two);
}
.ivu-menu-light.ivu-menu-vertical .ivu-menu-item-active:not(.ivu-menu-submenu) {
  background-color: var(--green_three);
}
.ivu-menu-light.ivu-menu-vertical
  .ivu-menu-item-active:not(.ivu-menu-submenu):after {
  background: var(--green_one);
}
.ivu-menu-vertical .ivu-menu-submenu .ivu-menu-item span {
  white-space: normal;
}
</style>



// WEBPACK FOOTER //
// src/pages/index.vue